export const VUEX_FILTERBAR_SELECTOR_ADD_PROP = 'VUEX_FILTERBAR_SELECTOR_ADD_PROP'
